module.exports = __webpack_public_path__ + "media/images/average-revenu-5a470c5fe7a705f9524ac6085a049fc7.svg";